import api from "../axios";

export const sendBrowserInfoOnError = (
  errorId: string,
  browserInfo: object,
) => {
  api.post("/browser-info/errors", {
    data: {
      error_id: errorId,
      ...browserInfo,
    },
  });
};
